import en from './en'
import zh from './zh'
export default {
  en: en,
  zh: zh
}



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/index.js